import { useEffect, useMemo, useState } from "react";
import CustomDataTable from "../../../components/CustomDataTable";
import { DateUtil } from "../../../utils/date";
import { ReportService } from "../../../services/ReportsService";
import useAccounts from "../../../hooks/useAccounts";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
import LoaderSmall from "../../../components/LoaderSmall";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
interface ConversationsTabProps {
    show: boolean,
}

function ConversationsTab({ show }: ConversationsTabProps) {

    const { t }= useTranslation();
    const {call ,isRequesting} = useRequest();
    const { account } = useCurrentAccount();
    
    const columns = useMemo(() => [
        {
            name: t("reports.chatbot.ticket"),
            sortable: true,
            selector: row => row.ticket_id,
        },
        {
            name: t("reports.chatbot.start-date"),
            sortable: true,
            selector: row => <p className="text-nowrap mb-0">{DateUtil.format(row.created_at)}</p>,
        },
        {
            name: t("reports.chatbot.end-date"),
            sortable: true,
            selector: row => <p className="text-nowrap mb-0">{DateUtil.format(row.updated_at)}</p>,
        },
        {
            name: t("reports.chatbot.duration"),
            sortable: true,
            selector: row => <p className="text-nowrap mb-0">{DateUtil.diff(row.created_at, row.updated_at)}</p>,
        },
        {
            name: t("reports.chatbot.status"),
            sortable: true,
            cell: (row) => {

                if (row.finished) {
                    return (<><span className="legend-indicator bg-info"></span> Finalizado</>)
                }

                return (<><span className="legend-indicator bg-warning text-nowrap mb-0"></span> En proceso</>)
            }
        },

    ], [])

    const [data, setData] = useState([])
    
    const [rangeFilter, setRangeFilter] = useState({
        start: '',
        end: '',
    })

    const highlights = useMemo(() => {
        return {
            total: data.length,
            in_progress: data.filter( d => !d.finished ).length,
            finished: data.filter( d => d.finished ).length,
        }
    }, [data])

    const getConversations = async () => {
        const { data } = await call(() => ReportService.getConversations({ 
            account_id: account.id,
            start_date: DateUtil.ISOFormat(rangeFilter.start), 
            end_date: DateUtil.ISOFormat(rangeFilter.end) 
        }));
        setData(data)
    }

    useEffect(() => {
        // getConversations()
        if(rangeFilter.start && rangeFilter.end) {
            getConversations()
        }
        
    }, [rangeFilter, account])


    const heightRequesting = useMemo(()=> {return isRequesting ? 'mt-50 mb-50':''},[isRequesting]);
    const render = () => {
        return (
            <>

                <div className=" mb-3 mb-lg-5">
                    <div className={`row gx-lg-6 relative ${heightRequesting}`}>
                        {
                            isRequesting ? <LoaderSmall/> :
                        <>
                        <div className="col-lg-4 mb-md-3 mb-3">
                            <div className="card card-sm">
                                <div className="card-body">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <h6 className="card-subtitle mb-3">{t("reports.chatbot.total-conversation")}</h6>
                                            <h1 className="card-title">{highlights.total}</h1>

                                        </div>

                                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle">
                                            <i className="bi-chat-square-fill"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            

                        </div>


                        <div className="col-lg-4 mb-md-3 mb-3">
                            <div className="card card-sm">
                                <div className="card-body">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <h6 className="card-subtitle mb-3">{t("reports.chatbot.in-process")}</h6>
                                            <h1 className="card-title">{highlights.in_progress}</h1>

                                        </div>

                                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle ms-3">
                                            <i className="bi-hourglass-split"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-4">
                            <div className="card card-sm">
                                <div className="card-body">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <h6 className="card-subtitle mb-3">{t("reports.chatbot.finished")}</h6>
                                            <h1 className="card-title">{highlights.finished}</h1>

                                        </div>

                                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle ms-3">
                                            <i className="bi-check-all"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                        }
                    </div>

                </div>

                <CustomDataTable
                    columns={columns}
                    data={data}
                    hideAccountsFilter
                    showDates
                    isLoading={isRequesting}
                    showExport={false}
                    onDatesChange={ (dates) => setRangeFilter(dates)}
                    filter={(row, term) => {
                        if (!term) return true;
      
                        return (
                          `${row.bot_id}`.match(new RegExp(`${term}`, "i")) ||
                          `${row.ticket_id}`.match(new RegExp(`${term}`, "i")) ||
                          `${DateUtil.format(row.created_at)}`.match(new RegExp(`${term}`, "i")) ||
                          `${DateUtil.format(row.updated_at)}`.match(new RegExp(`${term}`, "i"))
                        );
                      }}
                />


            </>
        )
    }

    return show ? render() : null
}
export default ConversationsTab